import { render, staticRenderFns } from "./therm-v2-defects-bulk-action.vue?vue&type=template&id=4fc9ca84"
import script from "./therm-v2-defects-bulk-action.vue?vue&type=script&lang=js"
export * from "./therm-v2-defects-bulk-action.vue?vue&type=script&lang=js"
import style0 from "./therm-v2-defects-bulk-action.vue?vue&type=style&index=0&id=4fc9ca84&prod&lang=scss"
import style1 from "./therm-v2-defects-bulk-action.vue?vue&type=style&index=1&id=4fc9ca84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports